import { apiPost } from "./apiClient";
import { createCachedFetcher } from "./cachedFetcher";

// Same cost-tier lookup RecordPaymentModal/PriceUpdateDrawer/PaymentLinkModal
// all use to suggest a delivery charge from the order's total supplier cost.
const fetchCostPricesRaw = createCachedFetcher(
  () => apiPost("/whatsapp/get_costprices", {}).then(res => {
    const rows = res.data?.data ?? res.data ?? [];
    return Array.isArray(rows) ? rows : [];
  }),
  { fallback: [] }
);

export function fetchCostPrices({ force = false } = {}) {
  return fetchCostPricesRaw(undefined, { force });
}

export function getCostPriceTier(costPrices, price) {
  return costPrices.find(t => price >= t.MinPrice && price <= t.MaxPrice) ?? null;
}

// Creates a row when `id` is omitted, updates it when present. All seven
// fields (customer_type/make_type/parts_type/MinPrice/MaxPrice/
// DeliveryCost/GP_Percentage) are required by the backend either way.
export function saveCostPriceRange(payload) {
  return apiPost("/whatsapp/update_costprices", payload).then(res => res.data);
}

export function disableCostPriceRange(id) {
  return apiPost("/whatsapp/disable_costprices", { id }).then(res => res.data);
}
